import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import MainLayout from "./layouts/MainLayout";
import Header from "./components/Header";
import GaRouteTracker from "./GaRouteTracker";
import AnalyticsConsentBanner from "./components/AnalyticsConsentBanner";
import InsightArticle from "./pages/InsightArticle";

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const ServiceOwners = lazy(() => import("./pages/ServiceOwners"));
const ServiceRenters = lazy(() => import("./pages/ServiceRenters"));
const ServiceCommunity = lazy(() => import("./pages/ServiceCommunity"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const SwitchToXLZ = lazy(() => import("./pages/SwitchToXLZ"));
const HowSwitchingWorks = lazy(() => import("./pages/HowSwitchingWorks"));
const Complaints = lazy(() => import("./pages/Complaints"));
const TermsOfUse = lazy(() => import("./pages/TermsOfUse"));
const ClientResources = lazy(() => import("./pages/ClientResources"));

export default function App() {
  return (
    <Router>
      <ScrollToTop />

      {/* Track SPA route changes (page_view) */}
      <GaRouteTracker />

      <Header />

      <MainLayout>
        <Suspense fallback={<div className="p-8">Loading…</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/service-owners" element={<ServiceOwners />} />
            <Route path="/service-renters" element={<ServiceRenters />} />
            <Route path="/service-community" element={<ServiceCommunity />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />

            <Route path="/switch-to-xlz" element={<SwitchToXLZ />} />
            <Route path="/how-switching-works" element={<HowSwitchingWorks />} />

            <Route path="/complaints" element={<Complaints />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/resources" element={<ClientResources />} />
            <Route path="/insights/:slug" element={<InsightArticle />} />
          </Routes>
        </Suspense>
      </MainLayout>

      {/* Analytics notice + opt-out (global) */}
      <AnalyticsConsentBanner />
    </Router>
  );
}
